<template>
  <div class="page-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'pageLayoutMain',
  data () {
    return {

    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {

    }
  }
}
</script>

<style lang="stylus" scoped>
  .page-main {
    padding-top 80px;
    min-height: 80vh;
  }
    @media screen and (max-width: 768px){
      .page-main{padding-top:1.1rem}
    }
</style>
